@for(count of [].constructor(skeletonCount); track $index;){
<div [id]="announcement?'Announcement':('post-'+$index)"
    class="tw-bg-white dark:tw-bg-dark-navy tw-shadow-md tw-rounded-lg tw-mb-4 tw-px-4 tw-py-3">
    <div class="tw-text-white tw-font-semibold tw-leading-relaxed" data-text="Announcement"
        [ngClass]="{'ribbon-box':announcement}">
        <div class="tw-flex tw-items-center tw-pb-1">
            <div class="tw-w-10 tw-h-10 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse"></div>
            <div class="tw-ml-4 tw-w-32 tw-h-4 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
            <div class="tw-ml-auto tw-w-20 tw-h-4 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse"></div>
        </div>

        <div class="tw-w-full tw-h-6 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse tw-my-2"></div>

        <div class="tw-w-full tw-h-3 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse tw-mb-1"></div>
        <div class="tw-w-full tw-h-3 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse tw-mb-1"></div>
        <div class="tw-w-1/2 tw-h-3 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse tw-mb-2"></div>
        <div class="tw-w-15 tw-h-3 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded tw-animate-pulse tw-mb-2"></div>

        <div class="tw-w-full tw-h-40 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded-md tw-animate-pulse"></div>

        <div class="tw-flex tw-space-x-2 tw-mt-3 tw-border-t tw-border-gray-200 dark:tw-border-charcoal">
            <div class="tw-w-16 tw-h-6 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse tw-mt-2">
            </div>
            <div class="tw-w-16 tw-h-6 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse tw-mt-2">
            </div>
            <div class="tw-w-20 tw-h-6 tw-bg-gray-300 dark:tw-bg-gray-700 tw-rounded-full tw-animate-pulse tw-mt-2">
            </div>
        </div>
    </div>
</div>
}